export default "__VITE_ASSET__338404d9__"